module.exports = __webpack_public_path__ + "dd0fc713c2d9ff34bcaed3d981316add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_15.jpg
// module id = 1663
// module chunks = 5